import type { ElementDefinition } from './types';
import type { TemplateProfile } from '../templates';
import { insertExhibit } from '../word/exhibit';

/** Element definition for half-width exhibit insertion. */
export const halfExhibitElement: ElementDefinition = {
  id: 'half-exhibit',
  label: 'Graph Half',
  icon: 'ArrowBetweenDownRegular',
  description: 'Single half-width graph exhibit',
  category: 'exhibit',
  async insertAsync(profile: TemplateProfile): Promise<void> {
    await insertExhibit('half', profile);
  },
};

/** Toolbar action for half-width exhibit insertion. */
export async function insertGraphHalfLayout(profile: TemplateProfile): Promise<void> {
  await insertExhibit('half', profile);
}
